import { createReducer, on } from '@ngrx/store';
import { PrizeRequestModel } from '../../_models/prize-request.model';
import { PrizeRequestsActions } from '../_actions/prize-requests.actions';

export interface PrizeRequestsState {
  list: {
    filters: any;
    data: ReadonlyArray<PrizeRequestModel>;
    total: number;
    loading: boolean;
    error: any;
  };
  selected: PrizeRequestModel | null;
  selectedLoading: boolean;
  selectedError: any;
  creating: boolean;
  createSuccess: boolean;
  createError: any;
}

export const initialState: PrizeRequestsState = {
  list: {
    filters: {},
    data: [],
    total: 0,
    loading: false,
    error: null,
  },
  selected: null,
  selectedLoading: false,
  selectedError: null,
  creating: false,
  createSuccess: false,
  createError: null,
};

export const prizeRequestsReducer = createReducer(
  initialState,

  // Crear solicitud
  on(PrizeRequestsActions.createRequest, (state) => ({
    ...state,
    creating: true,
    createSuccess: false,
    createError: null,
  })),
  on(PrizeRequestsActions.createRequestSuccess, (state, { request }) => ({
    ...state,
    creating: false,
    createSuccess: true,
    selected: request,
  })),
  on(PrizeRequestsActions.createRequestFailure, (state, { error }) => ({
    ...state,
    creating: false,
    createError: error,
  })),

  // Cargar mis solicitudes
  on(PrizeRequestsActions.loadMyRequests, (state, { filters }) => ({
    ...state,
    list: {
      ...state.list,
      filters,
      loading: true,
      error: null,
    },
  })),
  on(PrizeRequestsActions.loadMyRequestsSuccess, (state, { requests, total }) => ({
    ...state,
    list: {
      ...state.list,
      data: requests,
      total,
      loading: false,
    },
  })),
  on(PrizeRequestsActions.loadMyRequestsFailure, (state, { error }) => ({
    ...state,
    list: {
      ...state.list,
      loading: false,
      error,
    },
  })),

  // Cargar detalle
  on(PrizeRequestsActions.loadRequestDetail, (state) => ({
    ...state,
    selectedLoading: true,
    selectedError: null,
  })),
  on(PrizeRequestsActions.loadRequestDetailSuccess, (state, { request }) => ({
    ...state,
    selected: request,
    selectedLoading: false,
  })),
  on(PrizeRequestsActions.loadRequestDetailFailure, (state, { error }) => ({
    ...state,
    selectedLoading: false,
    selectedError: error,
  })),

  // Limpiar estado
  on(PrizeRequestsActions.clearSelectedRequest, (state) => ({
    ...state,
    selected: null,
    selectedLoading: false,
    selectedError: null,
  })),
  on(PrizeRequestsActions.clearCreateSuccess, (state) => ({
    ...state,
    createSuccess: false,
    createError: null,
  }))
);
